import React from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../ui/Modal";
import Button from "../ui/Button";

const ClimateChangePopup = ({ open, onClose, onExplore, transformOrigin }) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onClose={onClose}
      transformOrigin={transformOrigin}
      header={
        <h2 className="text-2xl font-bold text-black text-center mb-6 font-playfair">
          Climate change and caregiving
        </h2>
      }
      footer={
        <div className="flex justify-center pt-6">
          <Button
            title="Explore"
            onClick={() => {
              if (onExplore) {
                onExplore();
              } else {
                onClose();
                navigate("/tabs?tab=climate-change");
              }
            }}
          />
        </div>
      }
    >
      <div className="space-y-3">
        <p className="text-base font-normal leading-loose text-black mb-4">
          There is a fundamental link between the act of caring for people and
          caring for the planet. Both are essential for human survival. Both are
          exploited in the pursuit of short-term economic and material profit.
          The devastating impacts of climate change and environmental
          degradation are outcomes of these exploits, as are the immense social
          and gender inequalities arising from the exploitation of care labor.
          Climate change intensifies the work involved in caring for people,
          animals, plants, and places. It reduces the availability and quality
          of public services in marginalized communities, and directly and
          indirectly impacts the unfair distribution of unpaid care work that
          fuels gender inequality. The topics in this section include:
        </p>

        <ul className="space-y-1 text-base font-normal leading-loose text-black list-disc pl-6 mb-6">
          <li>The interdependence of climate change and the care sector</li>
          <li>
            Mitigating the care crisis arising due to climate-related
            emergencies
          </li>
          <li>Everyday environmental relations to health outcomes</li>
          <li>
            Recommendations for caregivers on preparing for climate change
          </li>
          <li>
            Climate change impacts and action in the Nooraverse (India,
            Bangladesh, Indonesia, Nepal)
          </li>
        </ul>
      </div>
    </Modal>
  );
};

export default ClimateChangePopup;
